<template>
    <div>
        <!-- upload在项目中，不需要处理 -->
        <div style="width: 100%;margin-bottom: 20px;">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">设置</el-breadcrumb-item>
                <el-breadcrumb-item>商城轮播图</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-form :inline="true" class="user-search" size="small">
            <el-form-item>
                <el-button size="small" type="danger" icon="el-icon-plus" @click="addform">添加</el-button>
            </el-form-item>
        </el-form>

        <!--列表-->
        <el-table size="small" :data="listData" highlight-current-row v-loading="tableloading" border
            element-loading-text="拼命加载中" style="width: 100%;">

            <el-table-column prop="linkType" label="类别" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{scope.row.linkType=='banner'?'首页轮播':scope.row.linkType=='link'?'内容':'按钮'}}</div>
                </template>
            </el-table-column>
            <el-table-column prop="title" label="按钮名称" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{scope.row.title?scope.row.title:'--'}}</div>
                </template>
            </el-table-column>
            <el-table-column prop="sort" label="排序" width="200" align="center">
            </el-table-column>

            <el-table-column prop="img" label="广告图片" width="400" align="center">
                <template slot-scope="scope">
                    <div class="demo-image__preview">
                        <el-image style="width: 100px; height: auto" :src="scope.row.img"
                            :preview-src-list="[scope.row.img]"></el-image>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="url" label="链接" min-width="300" align="center">

            </el-table-column>


            <el-table-column prop="createTime" label="添加时间" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{web.formatTime(scope.row.createTime,'Y-M-D h:m')}}</div>
                </template>
            </el-table-column>

            <el-table-column align="center" label="操作" width="400">
                <template slot-scope="scope">
                    <el-button size="mini" @click="handleEdit(scope.row)" icon="el-icon-edit" type="primary">修改</el-button>
                    <el-button size="mini" @click="handledelete(scope.row)" icon="el-icon-delete" type="danger">删除</el-button>
                    <!-- <el-button size="mini" type="info" @click="delete(scope.row)">删除</el-button> -->
                    <!-- <el-button size="mini" type="danger" @click="handleaddcomment(scope.$index, scope.row)" icon="el-icon-edit">评价</el-button> -->
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <!-- <Pagination :child-msg="pageparm" @callFather="callFather"></Pagination> -->

        <!-- 增加banner 图 || 编辑banner图 -->
       <el-dialog
      :close-on-click-modal="false" title="编辑" :visible.sync="Visible" width="50%" @click="closeDialog" center>

            <el-form class="user-search" :model="editForm" label-width="80px" size="small">
                <el-form-item label="排序">
                    <el-input placeholder="数字越小排在越前" v-model="editForm.sort" size="mini"></el-input>
                </el-form-item>

                <el-form-item label="图片上传">
                    <uploadone :url="editForm.img" @click="uploadone"  ></uploadone>  
            
                </el-form-item>
                <el-form-item label="类型">
                    <el-radio-group v-model="editForm.type">
                        <el-radio :label="1">首页滚动轮播图</el-radio>
                        <el-radio :label="2">内容</el-radio>
                        <el-radio :label="3">按钮[导航]</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="名字" v-if="editForm.type==3">
                    <el-input placeholder="名字" v-model="editForm.title" size="mini"></el-input>
                </el-form-item>
                <el-form-item label="链接" v-if="editForm.type!=2">
                    <el-input placeholder="/pages开头" v-model="editForm.url" size="mini"></el-input>
                </el-form-item>
            </el-form>
            <quill-edit @content="getContent" v-if="editForm.type==2"></quill-edit>

            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="addEdit">保存</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    //    import Pagination from '../../components/Pagination'
    import uploadone from '../../components/uploadone'
    import quillEdit from '../../components/quillEdit'
    import { deleteBanner, getAllBanners, addEditBanner } from '../../api/basisMG.js'
    export default {
        components: {
            // Pagination,
            uploadone,
            quillEdit
        },
        data() {
            //数据  
            return {
                showdelete: false,
                Visible: false,
                tableloading: false,
                loading: false,
                editForm: {
                    type: 1
                },
                editFormimg:'',
                listData: [

                ],
                // 分页参数
                pageparm: {
                    currentPage: 1,
                    pageSize: 5,
                    total: 10,
                    start: 0,
                    length: 5
                },


            };
        },

        watch: {},

        methods: {
              // 单个上传图
              uploadone(data){
                this.editForm.imgUrl = data
                this.editForm.img = data
               
            },
            deleteimg(){
                this.editFormimg = ""
                this.editForm.img= ""
            },
            showDelete1() {

                this.showdelete = true
            },
            hiddenDelete() {
                this.showdelete = false
            },
            handleRemove() { 
                this.editForm.img = ''
                this.editFormimg = ''
            },
            handleSuccess1(response, file, fileList) {

                this.uploadData = fileList
              
                this.editForm.img = response.data
                this.editFormimg = response.data
                console.log(this.editForm.img)

            },
            getContent(content) {
                console.log(content)
                this.editForm.content = content
            },
            getData() {
                getAllBanners().then((res) => {
                    if (res.code == 200) {
                        this.listData = res.data
                    }

                })
            },
            addEdit() {
                let that = this
                console.log(this.editForm)
                let type = this.editForm.type
                this.editForm.linkType = type == 1 ? 'banner' : type == 2 ? 'link' : 'button'
                addEditBanner(this.editForm).then((res) => {
                    if (res.code == 200) {
                        that.$message({
                            type: 'success',
                            message: '添加成功'
                        })
                        that.Visible = false
                        this.editForm = {}
                        this.editFormimg = ""
                        that.getData()
                    }
                })
            },
            handledelete(row) {
                let that = this
                deleteBanner(row).then((res) => {
                    if (res.code == 200) {
                        that.$message({
                            type: 'success',
                            message: '删除成功'
                        })
                        that.getData()
                    }
                })
            },
            upload(data) {
                console.log(data)
                this.editForm.imgUrl = data
                this.editForm.img = data
                console.log(this.editForm.imgUrl)
            },
            // 增加||编辑弹窗
            addform() {
                this.editForm = {
                    type: 1
                }
                this.Visible = true
            },
            handleEdit(row) {
                this.editForm = Object.assign({}, row)
                this.editFormimg = row.img
                console.log('row', this.editForm)
                this.Visible = true
            },
            // 关闭弹窗
            closeDialog() {
                this.Visible = false
            },
            // 提交
            submit() { },
            // 时间戳过滤
            formatTime(number, format) {
                const formateArr = ['Y', 'M', 'D', 'h', 'm', 's']
                const returnArr = []

                const date = new Date(number * 1000)
                returnArr.push(date.getFullYear())
                returnArr.push(this.formatNumber(date.getMonth() + 1))
                returnArr.push(this.formatNumber(date.getDate()))

                returnArr.push(this.formatNumber(date.getHours()))
                returnArr.push(this.formatNumber(date.getMinutes()))
                returnArr.push(this.formatNumber(date.getSeconds()))

                // eslint-disable-next-line
                for (const i in returnArr) {
                    format = format.replace(formateArr[i], returnArr[i])
                }
                return format
            },
            formatNumber(n) {
                n = n.toString()
                return n[1] ? n : `0${n}`
            },


            // 分页插件事件
            callFather(parm) {
                this.pageparm.currentPage  = parm.currentPage
                this.pageparm.pageSize =  parm.pageSize 
                this.pageparm.start  = parm.currentPage - 1
                this.pageparm.length =  parm.pageSize 
                this.formInline.start = parm.currentPage - 1
                this.formInline.length = parm.pageSize
                this.getdata(this.formInline)
            },
            addFun() { },
            submitFun() { }
        },
        // 创建前状态(里面是操作)
        beforeCreate() { },
        // 创建完毕状态(里面是操作)
        created() {
            this.getParams(this.$route.path)
            this.getData()
        },
        // 挂载前状态(里面是操作)
        beforeMount() { },
        // 挂载结束状态(里面是操作)
        mounted() { },
        // 更新前状态(里面是操作)
        beforeUpdate() { },
        // 更新完成状态(里面是操作)
        updated() { },
        // 销毁前状态(里面是操作)
        beforeDestroy() { },
        // 销毁完成状态(里面是操作)
        destroyed() { }
    };
</script>

<style>
    .el-image-viewer__close {
        top: 100px !important;
        right: 50% !important;
    }
</style>